/**
 * Bonus Counter Replacer Colleaction
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseCollection = require('common/base.collection');
    var server = require('server');
    var BaseModel = require('common/base.model');
    var bonusMixin = require('mixins/bonus.mixin');

    module.exports = BaseCollection.extend({

        mixins: [bonusMixin],

        model: BaseModel,

        bonusStatuses: {
            'ISSUED': 1,
            'ACCEPTED': 2,
            'ACTIVE': 3
        },

        parse: function(response) {
            return response.data || [];
        },

        sync: function(method, collection, options) {
            const { getDateForIms } = window.Playtech.API.formatter;

            if (method === 'read') {
                var fromDate = new Date();
                var toDate = new Date(fromDate);
                fromDate.setFullYear(fromDate.getFullYear() - 10);

                return server.send(_.extend({
                    ID: 31085,
                    description: 'Get bonuses',
                    responses: [31086, 31087],
                    limit: 450,
                    issuedAfterDate: getDateForIms(fromDate),
                    issuedBeforeDate: getDateForIms(toDate),
                    statusFilter: 0,
                    returnBonusTemplateDetails: true,
                    returnBonusStats: false,
                    returnGamingContexts: false,
                    returnGameWeightsConfigurations: false,
                    returnWageringCoefficients: false
                })).done(options.success).fail(options.error);
            }
        }
    });
});
